"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M8.26 7.262c0-.331.136-.649.378-.883a1.343 1.343 0 0 1 1.863 0l4.873 4.714a1.204 1.204 0 0 1 .375.911 1.19 1.19 0 0 1-.09.49 1.228 1.228 0 0 1-.285.414l-4.873 4.722a1.346 1.346 0 0 1-.934.37 1.34 1.34 0 0 1-.932-.374 1.248 1.248 0 0 1-.385-.9c0-.337.14-.66.388-.897l4.029-3.825-4.029-3.86a1.229 1.229 0 0 1-.378-.882Zm7.5 0c0-.331.136-.649.378-.883a1.342 1.342 0 0 1 1.863 0l4.873 4.714a1.204 1.204 0 0 1 .375.911 1.19 1.19 0 0 1-.09.49 1.228 1.228 0 0 1-.285.414l-4.873 4.722a1.346 1.346 0 0 1-.934.37 1.34 1.34 0 0 1-.932-.374 1.247 1.247 0 0 1-.385-.9c0-.337.14-.66.388-.897l4.029-3.825-4.029-3.86a1.228 1.228 0 0 1-.378-.882Z"
  })]
});